// src/config/gauges/optichiller1CompCT6.js
// Optichiller 1Comp CT6 — Gauge Config = ct5

export const optichiller1CompCT6GaugeConfig = [
  // Presión de Succión C1
  {
    key: "presSuccionComp1",
    title: "Pres. Succión Compresor 1",
    unit: "psi",
    ranges: [
      { min: 33, max: 40, color: "green" },
      { min: 28, max: 33, color: "yellow" },
      { min: 40, max: 68, color: "yellow" },
      { min: 0, max: 28, color: "red" },
      { min: 68, max: 100, color: "red" },
    ],
  },

    // Temp. Descarga C1
  {
    key: "tempDescargaComp1",
    title: "Temp. Descarga Compresor 1",
    unit: "°C",
    ranges: [
      { min: 45, max: 70, color: "green" },
      { min: 43, max: 45, color: "yellow" },
      { min: 70, max: 91, color: "yellow" },
      { min: 0, max: 43, color: "red" },
      { min: 91, max: 150, color: "red" },
    ],
  },

  // Temp. Proceso Entrada
  {
    key: "tempProcesoEntrada",
    title: "Temp. Proceso Entrada",
    unit: "°C",
    ranges: [
      { min: 7, max: 12, color: "green" },
      { min: 5, max: 7, color: "yellow" },
      { min: 12, max: 20, color: "yellow" },
      { min: 0, max: 5, color: "red" },
      { min: 20, max: 50, color: "red" },
    ],
  },

    // Temp. Proceso Salida
  {
    key: "tempProcesoSalida",
    title: "Temp. Proceso Salida",
    unit: "°C",
    ranges: [
      { min: 7, max: 12, color: "green" },
      { min: 5, max: 7, color: "yellow" },
      { min: 12, max: 20, color: "yellow" },
      { min: 0, max: 5, color: "red" },
      { min: 20, max: 50, color: "red" },
    ],
  },

  // Temp. Torre Entrada
  {
    key: "tempTorreEntrada",
    title: "Temp. Torre Entrada",
    unit: "°C",
    ranges: [
      { min: 28, max: 31, color: "green" },
      { min: 25, max: 28, color: "yellow" },
      { min: 31, max: 35, color: "yellow" },
      { min: 0, max: 25, color: "red" },
      { min: 35, max: 50, color: "red" },
    ],
  },

    // Temp. Torre Salida
  {
    key: "tempTorreSalida",
    title: "Temp. Torre Salida",
    unit: "°C",
    ranges: [
      { min: 32, max: 35, color: "green" },
      { min: 26, max: 32, color: "yellow" },
      { min: 35, max: 38, color: "yellow" },
      { min: 0, max: 26, color: "red" },
      { min: 38, max: 50, color: "red" },
    ],
  },


  // Presión de Descarga C1
  {
    key: "presDescargaComp1",
    title: "Pres. Descarga Compresor 1",
    unit: "psi",
    ranges: [
      { min: 100, max: 120, color: "green" },
      { min: 89, max: 100, color: "yellow" },
      { min: 120, max: 131, color: "yellow" },
      { min: 0, max: 89, color: "red" },
      { min: 131, max: 100000, color: "red" },
    ],
  },
];
